

export class SearchResultConfigModel {

  public display: string = null;
  public displayLeft: string = null;
  public displayRight: string = null;

  constructor(model?: Partial<SearchResultConfigModel>) {
    if (model)
      for (let key in this as SearchResultConfigModel)
        if (model[key])
          this[key] = model[key];
  }
}
